import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const cateringPackageBaseEndpoint = ENDPOINTS.CATERINGPACKAGE;

// Package Type API
export const cateringPackageApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["cateringPackageType"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCateringPackages: builder.query({
        query: () => `${cateringPackageBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "cateringPackageType" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      getCateringPackagesDropdown: builder.query({
        query: () => `${cateringPackageBaseEndpoint}/package-dropdown`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "cateringPackageType" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),

      addCateringPackage: builder.mutation({
        query: (requestData) => ({
          url: `${cateringPackageBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "cateringPackageType" }],
      }),
      updateCateringPackage: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${cateringPackageBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "packageType" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetCateringPackagesQuery,
  useGetCateringPackagesDropdownQuery,
  useAddCateringPackageMutation,
  useUpdateCateringPackageMutation,
} = cateringPackageApi;
